module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/linescape-launches-sailing-schedule/linescape-launches-sailing-schedule.component.scss
// module id = 853
// module chunks = 0